<template>
  <div class="new-help-detail">
    <mt-header fixed :title="titleText" class="title1">
      <mt-button slot="left" icon="back" @click="$router.go(-1)">返回</mt-button>
    </mt-header>
    <div>
      <div class="main-content" v-if="hasContent">
        <div>
          <div class="content-item" v-for="(item, index) in content" :key="index">
            <div class="title">
              <div>
                <svg-icon :icon-class="titleSvgPath" class-name="cur-icon symbol"></svg-icon>
                <span>{{ item.title }}</span>
              </div>
            </div>
            <div class="content">{{ item.content }}</div>
          </div>
        </div>
      </div>
      <div class="content-empty" v-else>
        <div class="img">
          <img :src="require('@/assets/help_empty@3x.png')" alt="" />
        </div>
        <div class="word">
          <span>这里什么都没有</span>
        </div>
        <div class="word">
          <span>去看看别的</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon';

export default {
  name: 'NewHelpDetailAjax',
  comments: { SvgIcon },
  data() {
    return {
      titleText: '',
      titleSvgPath: 'help_symbol',
      content: [],
      hasContent: true,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.titleText = this.$route.query.selectedTitle;
      const rows = this.$route.query.selectedData;
      this.hasContent = rows.length > 0;
      rows.forEach(item => {
        this.content.push({ title: item.question, content: item.answer });
      });
    });
  },
};
</script>
